import { jsx } from "panel";
import { ButtonEl } from "../button";
import { ButtonTheme } from "../button/constants";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-drop-menu-pane"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-drop-menu-pane-title"
  }, this.attr(`show-back-button`) && /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      elref: `backButton`,
      icon: `arrow-left`,
      theme: ButtonTheme.Tertiary,
      role: `button`
    },
    on: {
      click: this.helpers.clickedBackButton
    }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".mp-drop-menu-pane-title-label"
  }, this.attr(`header`))), /* @__PURE__ */ jsx("div", {
    sel: ".mp-drop-menu-pane-body"
  }, /* @__PURE__ */ jsx("slot", null)));
}
